// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
let nextInstanceId = 0;
const Uncategorized = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
  const instanceId = React.useState(() => `Uncategorized-${++nextInstanceId}`)[0];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 18}
      height={size ?? 18}
      fill="none"
      viewBox="0 0 18 18"
      ref={ref}
      {...props}
    >
      <g clipPath={`url(#${instanceId}-Uncategorized_a)`}>
        <path
          fill="currentColor"
          d="M9 13.36a.703.703 0 1 0 0-1.407.703.703 0 0 0 0 1.406M8.5 10.125v.5h1v-.5h-1m.5-.562v-.5h-.5v.5zm0 .562h.5v-.562h-1v.562zm0-.562v.5c1.454 0 2.75-1.045 2.75-2.47h-1c0 .751-.719 1.47-1.75 1.47zm2.25-1.97h.5c0-1.423-1.296-2.468-2.75-2.468v1c1.031 0 1.75.718 1.75 1.469zM9 5.626v-.5c-1.454 0-2.75 1.045-2.75 2.469h1c0-.75.719-1.469 1.75-1.469zM6.75 7.594h-.5v.281h1v-.281z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 15.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5"
        />
      </g>
      <defs>
        <clipPath id={`${instanceId}-Uncategorized_a`}>
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(Uncategorized);
export default ForwardRef;
